import l7 from './layout7.js';
import l11 from './layout11.js';
import l12 from './layout12.js';
import l13 from './layout13.js';
import l20 from './layout20.js';
import l21 from './layout21.js';
import l22 from './layout22.js';
import l23 from './layout23.js';
import l24 from './layout24.js';
import l27 from './layout27.js';
import l29 from './layout29.js';
import l30 from './layout30.js';
import l32 from './layout32.js';
import l33 from './layout33.js';
export default {
  l7: l7,
  l11: l11,
  l12: l12,
  l13: l13,
  l20: l20,
  l21: l21,
  l22: l22,
  l23: l23,
  l24: l24,
  l27: l27,
  l29: l29,
  l30: l30,
  l31: l30,
  l32: l32,
  l33: l33
};